import React, { useState } from 'react';
import { auth, db } from './firebase'; 
import { createUserWithEmailAndPassword, sendEmailVerification, signOut, updateProfile } from 'firebase/auth'; // 🌟 프로필 업데이트 도구 추가!
import { ref, set, get } from "firebase/database"; 
import { useNavigate } from 'react-router-dom';

function Signup() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [displayName, setDisplayName] = useState(''); // 🌟 이름/학번 저장용 상태 추가
  const [role, setRole] = useState('student'); 
  const navigate = useNavigate();
  const [teacherCode, setTeacherCode] = useState(''); 

  const handleSignup = async (e) => {
    e.preventDefault();
    
    if (password !== passwordConfirm) {
      alert("비밀번호가 일치하지 않습니다!");
      return;
    }
    if (password.length < 6) {
      alert("비밀번호는 6자리 이상이어야 합니다.");
      return;
    }
    if (!displayName) {
      alert("이름 또는 학번을 입력해주세요!");
      return;
    }
    
    if (role === 'teacher') {
      const snapshot = await get(ref(db, 'settings/teacherCode'));
      const realCode = snapshot.val() || 'chem1004'; // DB에 없으면 기본값 chem1004 사용

      if (teacherCode !== realCode) {
        alert("🚨 선생님 인증 코드가 틀렸습니다. 관리자에게 문의하세요.");
        return;
      }
    }

    // 1. 파이어베이스에 계정 생성
    createUserWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        const user = userCredential.user;
        
        // 2. 🌟 가입된 계정에 '이름표(displayName)' 달아주기
        updateProfile(user, { displayName: displayName }).then(() => {
          
          // 3. 장부(DB)에도 역할과 이름을 예쁘게 적어둡니다.
          set(ref(db, 'users/' + user.uid), {
            email: user.email,
            name: displayName,
            role: role 
          }).then(() => {
            
            // 4. 모든 저장이 끝나면 인증 메일을 보냅니다.
            sendEmailVerification(user).then(() => {
              alert("🎉 가입 성공! 입력하신 이메일로 인증 메일을 발송했습니다. 메일함의 링크를 클릭한 후 로그인해주세요.");
              signOut(auth).then(() => navigate('/'));
            });
            
          });
        });
      })
      .catch((error) => {
        if (error.code === 'auth/email-already-in-use') {
          alert("이미 가입된 이메일입니다.");
        } else {
          alert("회원가입 실패: " + error.message);
        }
      });
  };

  return (
    <div className="container" style={{ textAlign: 'center', marginTop: '10vh', fontFamily: 'sans-serif' }}>
      <h1 style={{ color: '#2c3e50' }}>📝 회원가입</h1>
      <p style={{ color: '#7f8c8d' }}>역할과 인적사항을 정확히 입력해주세요.</p>
      
      <form onSubmit={handleSignup} style={{ display: 'inline-block', textAlign: 'left', padding: '30px', border: '1px solid #ddd', borderRadius: '15px', backgroundColor: 'white', boxShadow: '0 4px 10px rgba(0,0,0,0.1)', width: '320px' }}>
        
        <div style={{ marginBottom: '20px', textAlign: 'center' }}>
          <label style={{ marginRight: '15px', cursor: 'pointer', fontWeight: 'bold' }}>
            <input type="radio" value="student" checked={role === 'student'} onChange={() => setRole('student')} style={{ marginRight: '5px' }} />
            👨‍🎓 학생
          </label>
          <label style={{ cursor: 'pointer', fontWeight: 'bold' }}>
            <input type="radio" value="teacher" checked={role === 'teacher'} onChange={() => setRole('teacher')} style={{ marginRight: '5px' }} />
            👩‍🏫 선생님
          </label>
        </div>
        {role === 'teacher' && (
        <div style={{ marginBottom: '15px', backgroundColor: '#fcf3cf', padding: '10px', borderRadius: '5px', border: '1px solid #f1c40f' }}>
          <label style={{ fontWeight: 'bold', fontSize: '0.9em', color: '#d35400' }}>비밀 인증 코드 (선생님 전용)</label>
          <input type="password" value={teacherCode} onChange={(e) => setTeacherCode(e.target.value)} required placeholder="인증 코드를 입력하세요" style={{ width: '100%', padding: '10px', marginTop: '5px', boxSizing: 'border-box', borderRadius: '5px', border: '1px solid #ccc' }} />
        </div>
        )}
        {/* 🌟 새롭게 추가된 이름/학번 입력칸 */}
        <div style={{ marginBottom: '15px' }}>
          <label style={{ fontWeight: 'bold', fontSize: '0.9em' }}>이름 및 소속 (학번)</label>
          <input type="text" value={displayName} onChange={(e) => setDisplayName(e.target.value)} required placeholder="예: 2218 장한재" style={{ width: '100%', padding: '10px', marginTop: '5px', boxSizing: 'border-box', borderRadius: '5px', border: '1px solid #ccc' }} />
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label style={{ fontWeight: 'bold', fontSize: '0.9em' }}>이메일</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="인증 메일을 받을 주소" style={{ width: '100%', padding: '10px', marginTop: '5px', boxSizing: 'border-box', borderRadius: '5px', border: '1px solid #ccc' }} />
        </div>
        
        <div style={{ marginBottom: '15px' }}>
          <label style={{ fontWeight: 'bold', fontSize: '0.9em' }}>비밀번호 (6자리 이상)</label>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required placeholder="비밀번호 입력" style={{ width: '100%', padding: '10px', marginTop: '5px', boxSizing: 'border-box', borderRadius: '5px', border: '1px solid #ccc' }} />
        </div>

        <div style={{ marginBottom: '25px' }}>
          <label style={{ fontWeight: 'bold', fontSize: '0.9em' }}>비밀번호 확인</label>
          <input type="password" value={passwordConfirm} onChange={(e) => setPasswordConfirm(e.target.value)} required placeholder="비밀번호 다시 입력" style={{ width: '100%', padding: '10px', marginTop: '5px', boxSizing: 'border-box', borderRadius: '5px', border: '1px solid #ccc' }} />
        </div>

        <button type="submit" style={{ width: '100%', padding: '12px', backgroundColor: '#27ae60', color: 'white', border: 'none', borderRadius: '5px', fontWeight: 'bold', cursor: 'pointer', fontSize: '1em' }}>
          가입하고 인증메일 받기
        </button>

        <div style={{ marginTop: '15px', textAlign: 'center' }}>
          <button type="button" onClick={() => navigate('/')} style={{ background: 'none', border: 'none', color: '#3498db', cursor: 'pointer', textDecoration: 'underline' }}>
            로그인으로 돌아가기
          </button>
        </div>
      </form>
    </div>
  );
}

export default Signup;